import { BaseResource, ResourceAction } from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";

const isUserAllowed = ResourceAction({
  name: "isUserAllowed",
  querySerializer: MSerializers.object({
    userId: MSerializers.integer,
    action: MSerializers.string,
  }),
  responseSerializer: MSerializers.boolean,
});

const userDirectories = ResourceAction({
  name: "userDirectories",
  querySerializer: MSerializers.object({
    userId: MSerializers.integer,
    permission: MSerializers.string,
  }),
  responseSerializer: MSerializers.array(MSerializers.string).nullable(),
});

const allUserPermissions = ResourceAction({
  name: "allUserPermissions",
  querySerializer: MSerializers.object({
    userId: MSerializers.integer,
  }),
  responseSerializer: MSerializers.array(MSerializers.string),
});

const isUserAllowedEach = ResourceAction({
  name: "isUserAllowedEach",
  method: "post",
  requestBodySerializer: MSerializers.object({
    user: MSerializers.object({
      id: MSerializers.integer,
    }),
    actions: MSerializers.array(MSerializers.string),
  }),
  responseSerializer: MSerializers.mapObject(MSerializers.boolean),
});

export const authorizationResource = BaseResource(["iam", "authorization"], {
  isUserAllowed,
  isUserAllowedEach,
  userDirectories,
  allUserPermissions,
});
